<div class="dx-field" style="padding-right: 15px !important;">
  <div class="dx-field-label">Order Status</div>
  <div class="dx-field-value">
    <dx-radio-group
      [items]="status"
      [(value)]="selected"
      (onValueChanged)="valueChanged()"
      layout="horizontal">
    </dx-radio-group>
  </div>
</div>
